import React from 'react'

export const ExchangeArrowIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#000',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    x="0"
    y="0"
    viewBox="0 0 512 512"
  >
    <g>
      <path
        d="m511.36 99.922-18.544 71.516a19.973 19.973 0 0 1-24.379 14.34L394.8 166.685a20 20 0 1 1 10.039-38.719l25.722 6.669C377.427 58.143 278.708 24.449 188.92 54.31a211.136 211.136 0 0 0-134 132.783 20 20 0 1 1-37.83-13A254.846 254.846 0 0 1 76.8 77.972a249.919 249.919 0 0 1 99.5-61.617A252.632 252.632 0 0 1 465.973 115.6l6.667-25.712a20 20 0 0 1 38.72 10.039zM482.5 312.49a20 20 0 0 0-25.413 12.417 211.136 211.136 0 0 1-134 132.783c-89.787 29.861-188.507-3.833-241.638-80.325l25.722 6.669a20 20 0 1 0 10.029-38.719l-73.64-19.093a20 20 0 0 0-24.379 14.34L.64 412.078a20 20 0 1 0 38.72 10.039l6.667-25.712A252.738 252.738 0 0 0 335.7 495.646a249.932 249.932 0 0 0 99.5-61.618 254.838 254.838 0 0 0 59.71-96.125 20 20 0 0 0-12.41-25.413z"
        fill={color}
      />
    </g>
  </svg>
)
